export const getErrorMessage = (value) => {
  return {
    type: "GET_ERROR_MESSAGE",
    payload: value,
  };
};
